export default __webpack_public_path__ + "static/media/pantry1-afterH-480w.d7e18fbf.avif";